import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaCascader } from "ecCom";

@observer
export default class CustomFieldItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaCascader.WeaCustomField
        ecId={`${this.props.ecId}_WeaCustomField@ertp61`}
        {...bindObj.bind()}
        values={toJS(bindObj.value)}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/CustomFieldItem.js